<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ 'Auftrag erstellen' | mrTranslate }}</span>
    </div>
    <div class="header-actions">
      <a href="javascript:void(0);" class="nav-link nav-icon" (click)="close()">
        <cds-icon shape="times" />
      </a>
    </div>
  </header>

  <div class="clr-row nxm" style="padding-left: 10px; padding-right: 10px">
    <clr-tabs class="w-100-p">
      @if (mangel?.rows.length) {
        <clr-tab>
          <button clrTabLink (click)="tabChange('mangel')" id="link1">
            {{ 'Mängel' | mrTranslate }}
          </button>
          <clr-tab-content id="content1" *clrIfActive="openTab == 'mangel'">
            <form
              class="width100 d-f col no-margin"
              clrForm
              [clrLayout]="'vertical'"
              [formGroup]="auftragGroup"
              (ngSubmit)="auftragGroup.valid && onSubmit()">
              <div id="auftrag-form-container">
                <clr-date-container style="grid-area: start;">
                  <label>{{ 'Startdatum' | mrTranslate }}</label>
                  <input
                    type="date"
                    clrDate
                    [ngModel]="auftragGroup.get('startdate').value | localeDate"
                    (ngModelChange)="auftragGroup.get('startdate').setValue(localeDate.tosql($event))"
                    [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
                    [disabled]="auftragGroup.disabled"
                    required />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Das Datum muss eingegeben werden' | mrTranslate }}
                  </clr-control-error>
                </clr-date-container>
                <clr-date-container style="grid-area: end;">
                  <label>{{ 'Enddatum' | mrTranslate }}</label>
                  <input
                    type="date"
                    clrDate
                    [ngModel]="auftragGroup.get('enddate').value | localeDate"
                    (ngModelChange)="auftragGroup.get('enddate').setValue(localeDate.tosql($event))"
                    [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
                    [disabled]="auftragGroup.disabled"
                    required />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Das Datum muss eingegeben werden' | mrTranslate }}
                  </clr-control-error>
                </clr-date-container>
                <clr-select-container>
                  <label>{{ 'Auftragnehmer' | mrTranslate }}</label>
                  <select clrSelect formControlName="auftragnehmer">
                    @for (firm of firmen; track firm) {
                      <option [ngValue]="+firm.ID">{{ firm.mFirma }}</option>
                    }
                  </select>
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                  </clr-control-error>
                </clr-select-container>
                <clr-control-container>
                  <label>{{ 'Auftragsart' | mrTranslate }}</label>
                  <app-datalist-input [datalist]="auftragsarten" formControlName="auftragsart" />
                </clr-control-container>
                <clr-select-container>
                  <label>{{ 'Auftragsgruppe' | mrTranslate }}</label>
                  <select clrSelect formControlName="gruppenid">
                    @for (groups of auftragsgroups; track groups) {
                      <option [ngValue]="+groups.id">
                        {{ groups.mBezeichnung }}
                      </option>
                    }
                  </select>
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                  </clr-control-error>
                </clr-select-container>
                <clr-input-container>
                  <label>{{ 'Auftragsnummer' | mrTranslate }}</label>
                  <input clrInput type="text" formControlName="auftragsnr" />
                </clr-input-container>
                <clr-textarea-container style="grid-area: bem;">
                  <label>{{ 'Bemerkung' | mrTranslate }}</label>
                  <textarea clrTextarea rows="1" formControlName="bemerkung"></textarea>
                </clr-textarea-container>
              </div>
              @if (mangel && mangel.rows) {
                <clr-datagrid
                  [clrDgSelectionType]="'multi'"
                  [(clrDgSelected)]="selected"
                  class="datagrid-compact fill-space">
                  @for (column of mangel.columns; track column) {
                    <clr-dg-column [clrDgField]="column.id">
                      <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['bildpfad'] }">
                        {{ column.id | titlecase | mrTranslate }}
                      </ng-container>
                    </clr-dg-column>
                  }
                  <clr-dg-row *clrDgItems="let row of mangel.rows" [clrDgItem]="row">
                    <clr-dg-action-overflow>
                      <button class="action-item" (click)="onEdit(row)">
                        {{ 'alternative Instandsetzung festlegen' | mrTranslate }}
                      </button>
                    </clr-dg-action-overflow>
                    @for (cell of mangel.columns; track cell) {
                      <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                    }
                  </clr-dg-row>
                  <clr-dg-footer>{{ mangel.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                </clr-datagrid>
                <button
                  class="btn btn-primary margin-10-t margin-12-l"
                  [disabled]="trial || !selected?.length || isStarting"
                  type="submit">
                  {{ 'Auftrag erstellen' | mrTranslate }}
                </button>
              }
            </form>
          </clr-tab-content>
        </clr-tab>
      }
      @if ((typ_Line_Point | objtype: 'point') && Opt_F_Drawing == 1 && isload == true) {
        <clr-tab class="w-100-p">
          <button clrTabLink (click)="tabChange('paint')" [title]="'Mangelskizzen' | mrTranslate">
            {{ 'Mangelskizzen' | mrTranslate }}
          </button>
          <clr-tab-content>
            <app-painting [setostammid]="ostammid" [setinittyp]="'2'" />
          </clr-tab-content>
        </clr-tab>
      }
    </clr-tabs>
  </div>
</div>

<clr-modal [(clrModalOpen)]="showaltInstandsetzung" [clrModalClosable]="true" [clrModalSize]="'lg'">
  <h3 class="modal-title">{{ 'alternative Instandsetzung festlegen' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm [formGroup]="altMangelGroup" style="margin-top: -20px">
      <div class="clr-row">
        @if (typ_Line_Point | objtype: 'line') {
          <div class="clr-col-12" style="margin-left: -20px">
            <div class="comboboxcontainer clr-form-control">
              <label for="altvon">{{ 'von' | mrTranslate }}</label>
              <div class="clr-control-container">
                <input
                  id="altumfang"
                  class="clr-input combobox"
                  placeholder=""
                  type="number"
                  name="altvon"
                  style="width: 100px; margin-left: 120px"
                  formControlName="altvon" />
              </div>
            </div>
          </div>

          <div class="clr-col-12" style="margin-left: -20px">
            <div class="comboboxcontainer clr-form-control">
              <label for="altbis">{{ 'bis' | mrTranslate }}</label>
              <div class="clr-control-container">
                <input
                  id="altbis"
                  class="clr-input combobox"
                  placeholder=""
                  type="number"
                  name="altbis"
                  style="width: 100px; margin-left: 120px"
                  formControlName="altbis" />
              </div>
            </div>
          </div>
        }

        <div class="clr-col-12" style="margin-left: -20px">
          <div class="comboboxcontainer clr-form-control">
            <label for="altinstandsetzungshinweis">{{ 'Instandsetzunghinweis' | mrTranslate }}</label>
            <div class="clr-control-container">
              <input
                id="altinstandsetzungshinweis"
                class="clr-input combobox"
                placeholder=""
                type="search"
                name="altinstandsetzungshinweis"
                style="width: 500px; margin-left: 120px"
                formControlName="altinstandsetzungshinweis"
                list="instandsetzungList" />
            </div>
            <datalist id="instandsetzungList">
              @for (c of listih; track c) {
                <option [value]="c.Item2">{{ c.Item2 }}</option>
              }
            </datalist>
          </div>
        </div>
        <div class="clr-col-12" style="margin-left: -20px">
          <div class="comboboxcontainer clr-form-control">
            <label for="altumfang">{{ 'Umfang' | mrTranslate }}</label>
            <div class="clr-control-container">
              <input
                id="altumfang"
                class="clr-input combobox"
                placeholder=""
                type="number"
                name="altumfang"
                style="width: 100px; margin-left: 120px"
                formControlName="altumfang" />
            </div>
          </div>
        </div>
        <div class="clr-col-12" style="margin-left: -20px">
          <div class="comboboxcontainer clr-form-control">
            <label for="altmengeneinheit">{{ 'Mengeneinheit' | mrTranslate }}</label>
            <div class="clr-control-container">
              <input
                id="altmengeneinheit"
                class="clr-input combobox"
                placeholder=""
                type="search"
                name="altmengeneinheit"
                style="width: 100px; margin-left: 120px"
                formControlName="altmengeneinheit"
                list="mehList" />
            </div>
            <datalist id="mehList">
              @for (c of meh; track c) {
                <option [value]="c">{{ c }}</option>
              }
            </datalist>
          </div>
        </div>
      </div>
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="editMangel()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="showaltInstandsetzung = false">{{ 'Beenden' | mrTranslate }}</button>
  </div>
</clr-modal>
